import { TypedEventEmitter } from '@/utils/TypedEventEmitter';
import type { IAppEvents } from '@/typescript/interfaces/IAppEvents';

// Importing this module instantiates the bus, which is why the emitter class
// lives in utils/ — needing the class must not pull the global instance in.
const Events = new TypedEventEmitter<IAppEvents>();

export { Events };
